import { events } from "@planzone/events";
import { updateNotification } from "./utils/updateNotification";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";

const reduceAddProjectVirtualResourceNotificationState = createStateReducer(
  initialState,
  {
    [events.addProjectVirtualResourceSucceeded]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "addProjectVirtualResource",
          flags: ["success"],
          args: { success: "true" },
        },
        state.queue,
      ),
    }),
    [events.addProjectVirtualResourceFailed]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "addProjectVirtualResource",
          flags: ["failure"],
          args: { failure: "true" },
        },
        state.queue,
      ),
    }),
  },
);

export { reduceAddProjectVirtualResourceNotificationState };
